"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _padStart2 = _interopRequireDefault(require("lodash/padStart"));

var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TimePickerUtil = _interopRequireDefault(require("./TimePickerUtil"));

var _TimeIcon = _interopRequireDefault(require("../Icons/TimeIcon"));

var _Input = _interopRequireDefault(require("../Input/Input"));

var _FormItemProvider = _interopRequireDefault(require("../Utility/FormItemProvider"));

var _CloseIcon = _interopRequireDefault(require("../Icons/CloseIcon"));

var _PopupProvider = _interopRequireDefault(require("../Utility/PopupProvider"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _TimePickerSelect = _interopRequireDefault(require("./TimePickerSelect"));

var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));

var _I18nManager = _interopRequireDefault(require("../../../managers/I18nManager"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

var _PropUtils = require("../../../utils/PropUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var InputWithLabel = (0, _FormItemProvider.default)(_Input.default);
/**
 * Time picker component
 */

var TimePicker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TimePicker, _React$Component);

  _createClass(TimePicker, null, [{
    key: "getDerivedStateFromProps",

    /**
     * @override
     * @param {object} props - next Props
     * @param {object} state - previous state
     * @return {object|null} new state object or null
     */
    value: function getDerivedStateFromProps(props, state) {
      if (!(0, _isUndefined2.default)(props.value)) {
        var timeObj = _TimePickerUtil.default.parseTimeValue(props.value, props);

        return _objectSpread({}, timeObj, {}, state, {}, props);
      }

      return null;
    }
  }]);

  function TimePicker(props) {
    var _this;

    _classCallCheck(this, TimePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimePicker).call(this, props));

    _initialiseProps.call(_assertThisInitialized(_this));

    var defaultSelectedHours = 8;
    var defaultSelectedMinutes = 0;
    var defaultSelectedSeconds = 0;

    if (props.defaultSelectedValue) {
      var defaultSelectedObj = _TimePickerUtil.default.parseTimeValue(props.defaultSelectedValue, props);

      if (defaultSelectedObj.error) {
        throw new Error('There was an error parsing defaultSelectedValue prop');
      } else {
        defaultSelectedHours = defaultSelectedObj.hours;
        defaultSelectedMinutes = defaultSelectedObj.minutes;
        defaultSelectedSeconds = defaultSelectedObj.seconds;
      }
    }

    var state = {
      hours: defaultSelectedHours,
      minutes: defaultSelectedMinutes,
      seconds: defaultSelectedSeconds
    };
    var value = props.value || props.defaultValue;

    if (!value) {
      // Set selected defaults here because we want to default what's selected
      // in the select options and not what is displayed in the input
      var defaultPlaceholder = _I18nManager.default.t('TimePicker', 'input_placeholder').replace('%s', _this.generateDisplayTime(defaultSelectedHours, defaultSelectedMinutes, defaultSelectedSeconds));

      state.placeholder = props.placeholder || defaultPlaceholder;
    } else {
      var timeObj = _TimePickerUtil.default.parseTimeValue(value, props);

      if (timeObj.error) {
        state.error = true;
        state.errorMessage = timeObj.errorMessage;
      } else {
        // If value is valid, take timeObj as the state so it can update the select options
        state = timeObj;
      }

      state.placeholder = props.placeholder;
      state.value = value;
    }

    state.popupVisible = false;
    state.error = state.error || props.error;
    _this.state = state;
    _this.isUncontrolled = (0, _isUndefined2.default)(props.value); // Keeps track if user is hovering over popup

    _this.isHoverPopup = false; // Keeps track if user is hovering over clear

    _this.isHoverClear = false;
    _this.needsValidation = false;
    return _this;
  }

  _createClass(TimePicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          popupClassName = _this$props.popupClassName,
          popupPlacement = _this$props.popupPlacement,
          getPopupContainer = _this$props.getPopupContainer;

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      return _react.default.createElement("div", {
        className: (0, _classnames.default)(className, "".concat(clsPrfx, "-timepicker ").concat(clsPrfx))
      }, _react.default.createElement(_PopupProvider.default, {
        action: "focus",
        popup: this.renderTimePickerPopup(),
        popupClassName: (0, _classnames.default)(popupClassName, "".concat(clsPrfx, "-timepicker-popup ").concat(clsPrfx, "-tooltip -light")),
        popupPlacement: popupPlacement,
        prebuiltPlacementMap: "offset10px",
        getPopupContainer: getPopupContainer,
        transitionType: "slide",
        popupVisible: this.state.popupVisible,
        onPopupVisibleChange: this.handleChangePopupVisible
      }, this.renderInputTrigger()));
    }
    /**
     * Render time picker popup
     * @returns {ReactElement} - Time picker popup
     */

  }, {
    key: "renderTimePickerPopup",
    value: function renderTimePickerPopup() {
      var content = _react.default.createElement("div", {
        className: "timepicker-container",
        onMouseLeave: this.handleMouseLeavePopup,
        onMouseEnter: this.handleMouseEnterPopup
      }, _react.default.createElement("div", {
        className: "timepicker-content"
      }, this.renderSelections()));

      return _react.default.createElement(_Tooltip.default.TooltipContent, {
        content: content
      });
    }
    /**
     * Render time picker popup trigger
     * @returns {ReactElement} - Time picker input trigger
     */

  }, {
    key: "renderInputTrigger",
    value: function renderInputTrigger() {
      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          inputProps = _this$props2.inputProps;
      var _this$state = this.state,
          popupVisible = _this$state.popupVisible,
          placeholder = _this$state.placeholder,
          value = _this$state.value,
          error = _this$state.error,
          errorMessage = _this$state.errorMessage;
      var inputSuffix;

      if (popupVisible && value) {
        inputSuffix = _react.default.createElement(_FlexLayout.default, {
          alignItems: "center",
          className: "timepicker-clear",
          onClick: this.handleClickClear,
          onMouseEnter: this.handleMouseEnterClear,
          onMouseLeave: this.handleMouseLeaveClear
        }, _react.default.createElement(_CloseIcon.default, {
          size: "small"
        }));
      } else {
        inputSuffix = _react.default.createElement(_TimeIcon.default, null);
      } // If value is undefined, set it to empty string so React does not complain
      // about switching from uncontrolled to controlled. We want to control all the time


      var inputValue = (0, _isUndefined2.default)(value) ? '' : value;
      return _react.default.createElement(InputWithLabel, _extends({
        className: "timepicker-input-trigger",
        value: inputValue,
        suffix: inputSuffix,
        placeholder: placeholder,
        disabled: disabled,
        error: error,
        helpText: errorMessage,
        onChange: this.handleChangeInput,
        onBlur: this.handleBlurInput
      }, inputProps));
    }
    /**
     * Render time picker popup selections
     * @returns {ReactElement} - Time picker popup selections
     */

  }, {
    key: "renderSelections",
    value: function renderSelections() {
      var _this2 = this;

      var hoursOptions = this._generateHoursOptions();

      var minutesOptions = this._generateMinutesOptions();

      var timePickerSelects = [_react.default.createElement(_TimePickerSelect.default, {
        key: "selectHours",
        className: "timepicker-hours-select",
        selectOptions: hoursOptions,
        value: this.state.hours,
        onClick: function onClick(value) {
          _this2.handleClickHoursValue(value);
        }
      }), _react.default.createElement(_TimePickerSelect.default, {
        key: "selectMinutes",
        className: "timepicker-minutes-select",
        selectOptions: minutesOptions,
        value: this.state.minutes,
        onClick: function onClick(value) {
          _this2.handleClickMinutesValue(value);
        }
      })];

      if (this.props.showSeconds) {
        var secondsOptions = this._generateSecondsOptions();

        timePickerSelects.push(_react.default.createElement(_TimePickerSelect.default, {
          key: "selectSeconds",
          className: "timepicker-seconds-select",
          selectOptions: secondsOptions,
          value: this.state.seconds,
          onClick: function onClick(value) {
            _this2.handleClickSecondsValue(value);
          }
        }));
      }

      if (this.props.format12Hours) {
        var ampmOptions = this._generateAMPMOptions();

        var ampm = this.getAMPM(this.state.hours);
        timePickerSelects.push(_react.default.createElement(_TimePickerSelect.default, {
          key: "selectAMPM",
          className: "timepicker-ampm-select",
          selectOptions: ampmOptions,
          value: ampm,
          onClick: function onClick(value) {
            _this2.handleClickAMPMValue(value);
          }
        }));
      }

      return _react.default.createElement(_FlexLayout.default, {
        itemSpacing: "0px"
      }, timePickerSelects);
    }
    /**
     * Generate display time
     * @param {number} hours - Hours value
     * @param {number} minutes - Minutes value
     * @param {number} seconds - Seconds value
     * @returns {string} - Time string to display
     */

  }, {
    key: "generateDisplayTime",
    value: function generateDisplayTime(hours, minutes, seconds) {
      var timeValue;

      var displayHours = this._getDisplayHours(hours);

      var displayMinutes = this._getDisplayMinutes(minutes);

      timeValue = "".concat(displayHours, ":").concat(displayMinutes);

      if (this.props.showSeconds) {
        var displaySeconds = this._getDisplaySeconds(seconds);

        timeValue += ":".concat(displaySeconds);
      }

      if (this.props.format12Hours) {
        var ampm = this.getAMPM(hours);

        if (ampm) {
          var displayAMPM = this._getDisplayAMPM(ampm);

          timeValue += " ".concat(displayAMPM);
        }
      }

      return timeValue;
    }
    /**
     * Get AM/PM value from hours
     * @param {number} hours - Hours value
     * @returns {string} - AM/PM value
     */

  }, {
    key: "getAMPM",
    value: function getAMPM(hours) {
      var ampm;

      if (!(0, _isUndefined2.default)(hours)) {
        if (hours >= 12) {
          ampm = TimePicker.AMPM.PM;
        } else {
          ampm = TimePicker.AMPM.AM;
        }
      }

      return ampm;
    }
    /**
     * Handle click from select options. Update time value and call callback props if defined
     * @param {number} hours - Hours value
     * @param {number} minutes - Minutes value
     * @param {number} seconds - Seconds value
     */

  }, {
    key: "handleClickValue",
    value: function handleClickValue(hours, minutes, seconds) {
      var timeValue;
      var timeObj = {
        hours: hours,
        minutes: minutes
      };

      if (this.props.showSeconds) {
        timeObj.seconds = seconds;
      } // If custom render is defined, use that to get the time value to be displayed


      if (this.props.renderInputValue) {
        timeValue = this.props.renderInputValue(timeObj);
      } else {
        timeValue = this.generateDisplayTime(hours, minutes, seconds);
      }

      var newState = _TimePickerUtil.default.parseTimeValue(timeValue, this.props);

      if (this.isUncontrolled) {
        newState.value = timeValue; // Clicking on selection option should always produce valid time value

        newState.error = false;
      }

      this.setState(newState);

      if (this.props.onChange) {
        this.props.onChange(timeValue, timeObj);
      }

      if (this.props.onErrorChange && this.props.error) {
        // Clicking on selection option should always produce valid time value
        this.props.onErrorChange(false, '');
      }
    }
    /**
     * Handler for when there is a change to input
     * @param {object} e - SyntheticEvent
     */

  }, {
    key: "_getDisplayHours",

    /**
     * Get hours value to be displayed
     * @param {number} value - Hours value to display
     * @returns {string} - Value to be displayed
     * @private
     */
    value: function _getDisplayHours(value) {
      if (this.props.format12Hours) {
        if (value === 0) {
          return 12;
        } else if (value > 12) {
          return value - 12;
        }

        return value;
      } // For 24 hours format, we want to make sure two digits are always displayed.
      // Pad with 0 if single digit


      return (0, _padStart2.default)(value, 2, '0');
    }
    /**
     * Get minutes value to be displayed
     * @param {number} value - Minutes value to displayed
     * @returns {string} - Value to be displayed
     * @private
     */

  }, {
    key: "_getDisplayMinutes",
    value: function _getDisplayMinutes(value) {
      // Make sure minutes are always displayed with two digits
      return (0, _padStart2.default)(value, 2, '0');
    }
    /**
     * Get seconds value to be displayed
     * @param {number} value - Seconds value to display
     * @returns {string} - Value to be displayed
     * @private
     */

  }, {
    key: "_getDisplaySeconds",
    value: function _getDisplaySeconds(value) {
      // Make sure seconds are always displayed with two digits
      return (0, _padStart2.default)(value, 2, '0');
    }
    /**
     * Get AMPM value to be displayed
     * @param {string} value - AMPM value to display
     * @returns {string} - Value to be displayed
     * @private
     */

  }, {
    key: "_getDisplayAMPM",
    value: function _getDisplayAMPM(value) {
      if (value === TimePicker.AMPM.PM) {
        return _I18nManager.default.t('TimePicker', 'PM');
      }

      return _I18nManager.default.t('TimePicker', 'AM');
    }
    /**
     * Get time object that is returned in callbacks
     * @returns {Object} - Time object that includes hours, minutes, seconds attributes
     * @private
     */

  }, {
    key: "_getTimeObj",
    value: function _getTimeObj() {
      var timeObj = {
        hours: this.state.hours,
        minutes: this.state.minutes
      };

      if (this.props.showSeconds) {
        timeObj.seconds = this.state.seconds;
      }

      return timeObj;
    }
    /**
     * Generate hours select options
     * @returns {Array} - Hours select options
     * @private
     */

  }, {
    key: "_generateHoursOptions",
    value: function _generateHoursOptions() {
      var _this$props3 = this.props,
          disabledHours = _this$props3.disabledHours,
          filteredHours = _this$props3.filteredHours,
          format12Hours = _this$props3.format12Hours;
      var disabledList = disabledHours ? disabledHours(this._getTimeObj()) : [];
      var filteredList = filteredHours ? filteredHours(this._getTimeObj()) : null;
      var options = [];

      if (format12Hours) {
        for (var i = 1; i <= 12; i++) {
          var value = i;

          if (this.state.hours < 12) {
            if (i === 12) {
              value = 0;
            }
          } else if (i !== 12) {
            value = i + 12;
          } // If filteredList is defined, check if value is there before pushing the option


          if (!filteredList || filteredList.indexOf(value) > -1) {
            options.push({
              value: value,
              title: this._getDisplayHours(i),
              disabled: disabledList.indexOf(value) > -1
            });
          }
        }
      } else {
        for (var _i = 0; _i < 24; _i++) {
          // If filteredList is defined, check if value is there before pushing the option
          if (!filteredList || filteredList.indexOf(_i) > -1) {
            options.push({
              value: _i,
              title: this._getDisplayHours(_i),
              disabled: disabledList.indexOf(_i) > -1
            });
          }
        }
      }

      return options;
    }
    /**
     * Generate minutes select options
     * @returns {Array} - Minutes select options
     * @private
     */

  }, {
    key: "_generateMinutesOptions",
    value: function _generateMinutesOptions() {
      var _this$props4 = this.props,
          disabledMinutes = _this$props4.disabledMinutes,
          filteredMinutes = _this$props4.filteredMinutes;
      var disabledList = disabledMinutes ? disabledMinutes(this._getTimeObj()) : [];
      var filteredList = filteredMinutes ? filteredMinutes(this._getTimeObj()) : null;
      var options = [];

      for (var i = 0; i < 60; i++) {
        var disabled = disabledList.indexOf(i) > -1; // If filteredList is defined, check if value is there before pushing the option

        if (!filteredList || filteredList.indexOf(i) > -1) {
          options.push({
            value: i,
            title: this._getDisplayMinutes(i),
            disabled: disabled
          });
        }
      }

      return options;
    }
    /**
     * Generate seconds select options
     * @returns {Array} - Seconds select options
     * @private
     */

  }, {
    key: "_generateSecondsOptions",
    value: function _generateSecondsOptions() {
      var _this$props5 = this.props,
          disabledSeconds = _this$props5.disabledSeconds,
          filteredSeconds = _this$props5.filteredSeconds;
      var disabledList = disabledSeconds ? disabledSeconds(this._getTimeObj()) : [];
      var filteredList = filteredSeconds ? filteredSeconds(this._getTimeObj()) : null;
      var options = [];

      for (var i = 0; i < 60; i++) {
        var disabled = disabledList.indexOf(i) > -1; // If filteredList is defined, check if value is there before pushing the option

        if (!filteredList || filteredList.indexOf(i) > -1) {
          options.push({
            value: i,
            title: this._getDisplaySeconds(i),
            disabled: disabled
          });
        }
      }

      return options;
    }
    /**
     * Generate ampm select options
     * @returns {Array} - AMPM select options
     * @private
     */

  }, {
    key: "_generateAMPMOptions",
    value: function _generateAMPMOptions() {
      var _this$props6 = this.props,
          disabledHours = _this$props6.disabledHours,
          filteredHours = _this$props6.filteredHours;
      var currentHours = this.state.hours;
      var disabledAM = false,
          disabledPM = false,
          filteredAM = true,
          filteredPM = true;
      var disabledList = disabledHours ? disabledHours(this._getTimeObj()) : [];
      var filteredList = filteredHours ? filteredHours(this._getTimeObj()) : null;

      if (currentHours >= 12) {
        if (disabledList.indexOf(currentHours - 12) > -1) {
          disabledAM = true;
        }
      } else if (disabledList.indexOf(currentHours + 12) > -1) {
        disabledPM = true;
      }

      var amOption = {
        value: TimePicker.AMPM.AM,
        title: this._getDisplayAMPM(TimePicker.AMPM.AM),
        disabled: disabledAM
      };
      var pmOption = {
        value: TimePicker.AMPM.PM,
        title: this._getDisplayAMPM(TimePicker.AMPM.PM),
        disabled: disabledPM
      };
      var ampmOptions = [];

      if (filteredList) {
        if (currentHours >= 12) {
          if (filteredList.indexOf(currentHours - 12) === -1) {
            filteredAM = false;
          }
        } else if (filteredList.indexOf(currentHours + 12) === -1) {
          filteredPM = false;
        }
      }

      if (filteredAM) {
        ampmOptions.push(amOption);
      }

      if (filteredPM) {
        ampmOptions.push(pmOption);
      }

      return ampmOptions;
    }
  }]);

  return TimePicker;
}(_react.default.Component);

exports.default = TimePicker;
TimePicker.AMPM = {
  AM: 'AM',
  PM: 'PM'
};
TimePicker.defaultProps = {
  format12Hours: true,
  popupPlacement: 'bottomLeft',
  inputProps: {}
};
TimePicker.propTypes = {
  /**
   * Whether or not to format in 12 hour time format (showing AM/PM)
   */
  format12Hours: _propTypes.default.bool,

  /**
   * Whether or not to show seconds options
   */
  showSeconds: _propTypes.default.bool,

  /**
   * Default time value for uncontrolled component behavior
   */
  defaultValue: _propTypes.default.string,

  /**
   * Time value with format HH:mm, HH:mm:ss, h:mm a or h:mm:ss a depending on format12Hours and showSeconds props
   * Setting this prop will make this component controlled
   */
  value: _PropUtils.checkControlType,

  /**
   * Default selected time options if defaultValue and value are not provided
   */
  defaultSelectedValue: _propTypes.default.string,

  /**
   * Show input error style.
   */
  error: _propTypes.default.bool,

  /**
   * Error message to display
   */
  errorMessage: _propTypes.default.string,

  /**
   * This must be unique across all input elements on the page
   * to ensure proper focus when label is clicked.
   */
  id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Function to get disabled hours depending on current selected values
   * @param {Object} timeObj - Object with hours, minutes, seconds
   * @returns {Array} - Hours (0-23) to be disabled
   */
  disabledHours: _propTypes.default.func,

  /**
   * Function to get disabled minutes depending on current selected values
   * @param {Object} timeObj - Object with hours, minutes, seconds
   * @returns {Array} - Minutes (0-59) to be disabled
   */
  disabledMinutes: _propTypes.default.func,

  /**
   * Function to get disabled seconds depending on current selected values
   * @param {Object} timeObj - Object with hours, minutes, seconds
   * @returns {Array} - Seconds (0-59) to be disabled
   */
  disabledSeconds: _propTypes.default.func,

  /**
   * Function to get filtered hours depending on current selected values
   * @param {Object} timeObj - Object with hours, minutes, seconds
   * @returns {Array} - Hours (0-23) to display
   */
  filteredHours: _propTypes.default.func,

  /**
   * Function to get filtered minutes depending on current selected values
   * @param {Object} timeObj - Object with hours, minutes, seconds
   * @returns {Array} - Minutes (0-59) to display
   */
  filteredMinutes: _propTypes.default.func,

  /**
   * Function to get filtered seconds depending on current selected values
   * @param {Object} timeObj - Object with hours, minutes, seconds
   * @returns {Array} - Seconds (0-59) to display
   */
  filteredSeconds: _propTypes.default.func,

  /**
   * className is used to add extra class for adding new style to override default
   */
  className: _propTypes.default.string,

  /**
   * Parse function used for custom parsing of input value
   * @param {string} value - Time value to parse
   * @returns {hours: number, minutes: number, seconds: number, error: boolean, errorMessage: string} - Time object
   */
  parseInputValue: _propTypes.default.func,

  /**
   * Render function used for custom rendering of input value
   * @param {Object} timeObj - Object with hours, minutes, seconds data used for rendering
   */
  renderInputValue: _propTypes.default.func,

  /**
   * Additional properties to pass through to input
   */
  inputProps: _propTypes.default.object,

  /**
   * Customize additional class name to the time picker select
   */
  popupClassName: _propTypes.default.string,

  /**
   * Placement position of time picker over children
   */
  popupPlacement: _propTypes.default.string,

  /**
   * Function to return a DOM element to use as container for the select options
   * Otherwise `<body>` is used
   * Mandatory if the select options is in a scrollable container other than body
   * otherwise the Options won't scroll with the Select
   */
  getPopupContainer: _propTypes.default.func,

  /**
   * Placeholder text on the time picker input.
   */
  placeholder: _propTypes.default.string,

  /**
   * Disabled prop is used to disable the TimePicker.
   */
  disabled: _propTypes.default.bool,

  /**
   * Callback executed when time has changed
   */
  onChange: _propTypes.default.func,

  /**
   * Callback executed when there is a change to error state
   */
  onErrorChange: _propTypes.default.func
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleChangeInput = function (e) {
    var value = e.target.value;

    var parsedTimeObj = _TimePickerUtil.default.parseTimeValue(value, _this3.props);

    var isValid = !parsedTimeObj.error;
    _this3.needsValidation = true;
    var timeObj;
    var newState = {};

    if (isValid && value) {
      // Update select options if input is valid and not empty
      newState = _objectSpread({}, parsedTimeObj);
      timeObj = {
        hours: parsedTimeObj.hours,
        minutes: parsedTimeObj.minutes,
        seconds: parsedTimeObj.seconds
      };
    }

    if (_this3.isUncontrolled) {
      newState.value = value;

      if (isValid) {
        newState.error = false;
        newState.errorMessage = '';
      }
    }

    _this3.setState(newState);

    if (_this3.props.onChange) {
      _this3.props.onChange(value, timeObj);
    } // Call onErrorChange if there was an error, but input is now valid


    if (_this3.props.onErrorChange && _this3.props.error && isValid) {
      _this3.props.onErrorChange(false, '');
    }
  };

  this.handleBlurInput = function (e) {
    // If user is hovering over the popup, don't handle the blur input because
    // the blur can be caused by clicking on a select option. This also applies
    // to the clear button inside the Input component
    if (!_this3.isHoverPopup && !_this3.isHoverClear) {
      if (_this3.needsValidation) {
        var value = e.target.value;

        var timeObj = _TimePickerUtil.default.parseTimeValue(value, _this3.props);

        var hasError = timeObj.error;

        if (_this3.isUncontrolled) {
          _this3.setState({
            error: hasError,
            errorMessage: timeObj.errorMessage
          });
        }

        if (_this3.props.onErrorChange && _this3.props.error !== hasError) {
          _this3.props.onErrorChange(hasError, timeObj.errorMessage);
        }

        _this3.needsValidation = false;
      }
    } else {
      // If blur event was caused by clicking inside the popup, refocus the input
      e.currentTarget.focus();
    }
  };

  this.handleChangePopupVisible = function (visible) {
    // If user is hovering over the popup, don't close it. Since popup is shown
    // based on focus action on input, clicking an item in the popup can trigger
    // this event because it blurs the input. This also applies to the clear button
    // inside the Input component
    if (!visible && (_this3.isHoverPopup || _this3.isHoverClear)) {
      return;
    }

    if (!_this3.props.disabled) {
      _this3.setState({
        popupVisible: visible
      });
    }
  };

  this.handleClickClear = function () {
    // Component will rerender without the clear button so mouseleave event for
    // clear button won't get triggered and this.isHoverClear won't get set to false
    // as expected. We'll have set it here as well.
    if (_this3.isHoverClear) {
      _this3.isHoverClear = false;
    }

    if (_this3.isUncontrolled) {
      _this3.setState({
        value: '',
        error: false,
        errorMessage: ''
      });
    }

    if (_this3.props.onChange) {
      _this3.props.onChange('', undefined);
    }

    if (_this3.props.onErrorChange && _this3.props.error) {
      _this3.props.onErrorChange(false, '');
    }
  };

  this.handleClickHoursValue = function (value) {
    _this3.handleClickValue(value, _this3.state.minutes, _this3.state.seconds);
  };

  this.handleClickMinutesValue = function (value) {
    _this3.handleClickValue(_this3.state.hours, value, _this3.state.seconds);
  };

  this.handleClickSecondsValue = function (value) {
    _this3.handleClickValue(_this3.state.hours, _this3.state.minutes, value);
  };

  this.handleClickAMPMValue = function (value) {
    var hours = _this3.state.hours;

    if (value === TimePicker.AMPM.AM && hours >= 12) {
      hours -= 12;
    } else if (value === TimePicker.AMPM.PM && hours < 12) {
      hours += 12;
    }

    _this3.handleClickValue(hours, _this3.state.minutes, _this3.state.seconds);
  };

  this.handleMouseLeavePopup = function () {
    _this3.isHoverPopup = false;
  };

  this.handleMouseEnterPopup = function () {
    _this3.isHoverPopup = true;
  };

  this.handleMouseLeaveClear = function () {
    _this3.isHoverClear = false;
  };

  this.handleMouseEnterClear = function () {
    _this3.isHoverClear = true;
  };
};